const e = {
  name: "CheckmarkSquareFilled",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2 5C2 3.34315 3.34315 2 5 2H19C20.6569 2 22 3.34315 22 5V19C22 20.6569 20.6569 22 19 22H5C3.34315 22 2 20.6569 2 19V5ZM17.9144 9.00003L16.5002 7.58582L10.5002 13.5858L7.50015 10.5858L6.08594 12L10.5002 16.4142L17.9144 9.00003Z" fill="currentColor"/>
</svg>
  `
};
export {
  e as CheckmarkSquareFilled
};
